import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { useHistory } from "react-router";
import { __ } from "@jti/fe-common";
import { Button, PageTitle } from "@jti/ui";
import styles from "./ExpiredEmail.module.scss";
const ExpiredEmail = () => {
    const history = useHistory();
    const onLogin = () => {
        history.push("/login");
    };
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: `${__("auth.expired_email.title")}`, variant: "back" }), _jsxs("div", { className: styles.container, children: [_jsx("p", { className: styles.text, children: __("auth.expired_email.text") }), _jsx(Button, { "data-testid": "login-button", className: styles.loginBtn, type: "button", color: "primary", onClick: onLogin, children: __("auth.expired_email.login") })] })] }));
};
export default memo(ExpiredEmail);
